var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.returnUrl)?_c('div',{staticClass:"m-wap-return",on:{"click":_vm.doReturn}},[_c('img',{staticClass:"return_img",attrs:{"src":require("../assets/images/icon_return.png")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }